<template>
  <v-row
    id="redemption-history"
    justify="center"
  >
    <v-col
      cols="12"
      md="8"
    >
      <back-button justify="start" />
    </v-col>
    <v-col
      cols="12"
      md="8"
    >
      <div v-if="hasRedeemedItems">
        <redeemed-item
          v-for="item in redeemedItems"
          :key="item.referenceOrderID"
          :item="item"
          @resend-reward="openResendDialog"
        />
      </div>
      <div
        v-intersect="{
          handler: onIntersect,
          options: {
            rootMargin: '0px 0px 0px 0px'
          }
        }"
        class="d-flex align-center justify-center py-4"
      >
        <v-progress-circular
          v-if="loading"
          color="primary"
          indeterminate
        />
      </div>
    </v-col>
    <v-col
      cols="12"
      md="8"
    >
      <no-redeemed-items v-if="showNoRedeemedItemsImage" />
      <need-help v-if="hasRedeemedItems && !chatBotEnabled" />
    </v-col>
    <resend-reward-dialog
      :open="resendDialog.open"
      :item="resendDialog.item"
      @close="closeResendDialog"
    />
  </v-row>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { GET_NO_MORE_ITEMS, GET_REDEMPTION_HISTORY } from '@/store/get-types'
import {
  FETCH_REDEMPTION_HISTORY,
  RESET_REDEMPTION_HISTORY
} from '@/store/action-types'
import RedeemedItem from '@/components/history/RedeemedItem'
import NeedHelp from '@/components/shared/NeedHelp'
import NoRedeemedItems from '@/components/history/NoRedeemedItems'
import BackButton from '@/components/footer/BackButton'
import ResendRewardDialog from '@/components/history/ResendRewardDialog'
import {
  RX_ADA_PROACTIVE,
  SVP_ADA_CHATBOT_ENABLED
} from '@/plugins/split/ActiveSplits'
import * as orderHistoryEvents from '@/plugins/segment/SegmentConstants'
import { REDEMPTION_HISTORY_PAGE_WITH_0_REDEMPTIONS_CAMPAIGN_KEY } from '@/components/shared/ada/ada-container'

export default {
  name: 'RedemptionHistory',
  components: {
    RedeemedItem,
    NeedHelp,
    NoRedeemedItems,
    BackButton,
    ResendRewardDialog
  },

  data () {
    return {
      loading: false,
      resendDialog: {
        open: false,
        item: null
      }
    }
  },
  computed: {
    ...mapGetters({
      redeemedItems: GET_REDEMPTION_HISTORY,
      noMoreItems: GET_NO_MORE_ITEMS
    }),
    chatBotEnabled () {
      return this.$isSplitEnabled(SVP_ADA_CHATBOT_ENABLED)
    },
    hasRedeemedItems () {
      return this.redeemedItems && this.redeemedItems.length
    },
    showNoRedeemedItemsImage () {
      return !this.hasRedeemedItems && !this.loading
    }
  },
  destroyed () {
    this.resetRedemptionHistory()
  },
  methods: {
    ...mapActions({
      fetchRedemptionHistory: FETCH_REDEMPTION_HISTORY,
      resetRedemptionHistory: RESET_REDEMPTION_HISTORY
    }),
    onIntersect (entries) {
      if (
        !this.noMoreItems ||
        (entries[0].isIntersecting && !this.noMoreItems)
      ) {
        this.fetchRedeemedItems()
      }
    },
    async fetchRedeemedItems () {
      try {
        this.loading = true
        await this.fetchRedemptionHistory()
        if (!this.hasRedeemedItems && this.$isSplitEnabled(RX_ADA_PROACTIVE)) {
          this.$adaChatbot.triggerCampaign(
            REDEMPTION_HISTORY_PAGE_WITH_0_REDEMPTIONS_CAMPAIGN_KEY
          )
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
    openResendDialog (item) {
      this.$segment.track(orderHistoryEvents.RESEND_DIALOG_OPENED)
      this.resendDialog.open = true
      this.resendDialog.item = item
    },
    closeResendDialog () {
      this.resendDialog.open = false
      this.resendDialog.item = null
    }
  }
}
</script>
